import { gql } from '@apollo/client';

export const queryCurrentUser = gql`
  query ($id: Float!) {
    readOneApplicationUser(id: $id) {
      id
      adId
      name
      emailAddress
    }
  }
`;

export const allDepartmentDropdown = gql`
  query {
    readAllDepartments: readDepartmentsAndDivisionsNoDC {
      id
      Abbreviation
      Name
    }
  }
`;

export const getRequests = gql`
  query {
    getRequests {
      id
      requestNumber
      requestorName
      requestorPhoneNumber
      requestorEmail
      needsBarcode
      chargeAccount
      equipmentType
      equipmentCategory
      deliveryLocation
      deliveryDate
      requestingDepartment
      needsBarcode
      quantity
      propertyCoordinator
      notes
      status
      isCovid
      attachment
      orderDate
      orderNumber
      orderAmount
      vendor
      oitNotes
      barcodeType
      requestDate
      requestorDivision
      fulfillingDepartment
      fulfillingDivision
      fulfillingDepartmentName
    }
  }
`;

export const pageEoRiView = gql`
 query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageEoRiView(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
      table
      id
      status
      description1
      description2
      description3
      remarks1
      remarks2
      remarks3
      currentQuantity
      originalQuantity
      majorAccountingClass
      majorEquipmentClass
      originalPurchaser
      physicalOwner
      categoryCode6
      serialNumber
      newOrUsed
      function
      accountNumber
      parentNumber
      department
      manufacturer
      location
      businessUnit
      barCode
      assetNumber
      companyNumber
      poNumber
      deldAcqdDate
      equipmentStatus
      locationDescription
      updateDate
      updateType
      toDeptId
      oitDCId
      requestItemFYNumber
      amountPaid
      dateEnteredInEnterpriseOne
      requestId
      needsImaging
      attachment
      isCovid
      deployed
      }
    }
  }`;

export const pageRequests = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageRequests(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        id
        requestNumber
        requestorName
        requestorPhoneNumber
        requestorEmail
        needsBarcode
        chargeAccount
        equipmentType
        equipmentCategory
        deliveryLocation
        deliveryDate
        requestingDepartment
        needsBarcode
        quantity
        propertyCoordinator
        notes
        status
        isCovid
        attachment
        orderDate
        orderNumber
        orderAmount
        vendor
        oitNotes
        barcodeType
        requestDate
        requestorDivision
        fulfillingDepartment
        fulfillingDivision
        fulfillingDepartmentName
      }
    }
  }
`;
// query ($deptId: Float!, $deptAbbr: String!) {
//   pageRequestsWithCustomQuery(deptId: $deptId, deptAbbr: $deptAbbr) {

export const pageReceivingRequested = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageRequestsWithCustomQuery(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        id
        requestNumber
        requestorName
        requestorPhoneNumber
        requestorEmail
        needsBarcode
        chargeAccount
        equipmentType
        equipmentCategory
        deliveryLocation
        deliveryDate
        requestingDepartment
        needsBarcode
        quantity
        propertyCoordinator
        notes
        status
        isCovid
        attachment
        orderDate
        orderNumber
        orderAmount
        vendor
        oitNotes
        barcodeType
        requestDate
        requestorDivision
        fulfillingDepartment
        fulfillingDivision
        fulfillingDepartmentName
      }
    }
  }
`;

export const GET_REQUEST_BY_ID = gql`
  query requestById($id: Int!) {
    requestById(id: $id) {
      requestId
      requestNumber
      requestorName
      requestorPhoneNumber
      requestorEmail
      needsBarcode
      equipmentType
      chargeAccount
      equipmentCategory
      deliveryLocation
      deliveryDate
      requestingDepartment {
        Name
      }
      needsBarcode
      quantity
      propertyCoordinatorId
      propertyCoordinator {
        name
      }
      purchaseOrderNumber
      status
      notes
      isCovid
      attachment
      orderDate
      orderNumber
      orderAmount
      vendor
      oitNotes
      barcodeType
      requestDate
      requestorDivision
      oitStock
      fulfillingDivision
      fulfillingDepartment
      fullfillingDepartmentName {
        Name
      }
    }
  }
`;

export const UPDATE_REQUEST = gql`
  mutation updateRequest($input: RequestInput!) {
    updateRequest(input: $input) {
      requestId
    }
  }
`;

export const pageRequestedItems = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageRequestedItems(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        requestedItemId
        barcode
        assetNumber
        department
        deliveryDate
        dateEnteredInEnterpriseOne
        description1
        description2
        description3
        requestNumber
        requestItemFYNumber
        serialNumber
        purchaseOrderNumber
        accountNumber
        parentNumber
        amountPaid
        originalQuantity
        currentQuantity
        remarks1
        remarks2
        remarks3
        physicalOwner
        originalPurchaser
        newOrUsed
        companyNumber
        responsibleBusinessUnit
        location
        majorAccountingClass
        majorEquipmentClass
        manufacturer
        function
        categoryCode6
        status
        needsImaging
        isCovid
        attachment
      }
    }
  }
`;

export const pageEOneUpdates = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageEOneUpdates(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        updateId
        assetNumber
        description1
        description2
        description3
        updateStatus
        accountNumber
        additionalRemarks
        additionalRemarks2
        additionalRemarks3
        assetItemCurrentQuantity
        assetItemOriginalQuantity
        barCode
        assetNumber
        businessUnit
        categoryCode6
        companyNumber
        dateAcquired
        department
        equipmentStatus
        itemFunction
        location
        locationDescription
        majorAccountingClass
        majorEquipmentClass
        manufacturer
        newOrUsed
        originalPurchaser
        parentNumber
        physicalOwner
        poNumber
        serialNumber
        updateDate
        updateType
      }
    }
  }
`;

export const GET_REQUESTED_ITEM_BY_ID = gql`
  query requestedItemById($id: Int!) {
    requestedItemById(id: $id) {
      id
      barcode
      assetNumber
      department
      deliveryDate
      dateEnteredInEnterpriseOne
      description1
      description2
      description3
      request {
        requestId
        requestNumber
      }
      requestId
      requestItemFYNumber
      serialNumber
      purchaseOrderNumber
      accountNumber
      parentNumber
      amountPaid
      originalQuantity
      currentQuantity
      remarks1
      remarks2
      remarks3
      physicalOwner
      originalPurchaser
      newOrUsed
      companyNumber
      responsibleBusinessUnit
      location
      majorAccountingClass
      majorEquipmentClass
      manufacturer
      function
      categoryCode6
      status
      needsImaging
      isCovid
      attachment
    }
  }
`;

export const GET_EONE_ITEM_BY_ID = gql`
  query readOneById($id: Int!) {
    readOneById(id: $id) {
      id
      assetNumber
      description1
      description2
      description3
      updateStatus
      accountNumber
      additionalRemarks
      additionalRemarks2
      additionalRemarks3
      assetItemCurrentQuantity
      assetItemOriginalQuantity
      barCode
      businessUnit
      categoryCode6
      companyNumber
      dateAcquired
      department
      equipmentStatus
      itemFunction
      location
      locationDescription
      majorAccountingClass
      majorEquipmentClass
      manufacturer
      newOrUsed
      originalPurchaser
      parentNumber
      physicalOwner
      poNumber
      serialNumber
      updateDate
      updateType
    }
  }
`;

export const requestedItemsByRequestId = gql`
  query requestedItemsByRequestId($id: Float!) {
    requestedItemsByRequestId(id: $id) {
      id
      barcode
      assetNumber
      department
      deliveryDate
      dateEnteredInEnterpriseOne
      description1
      description2
      description3
      requestItemFYNumber
      serialNumber
      purchaseOrderNumber
      accountNumber
      parentNumber
      amountPaid
      originalQuantity
      currentQuantity
      remarks1
      remarks2
      remarks3
      physicalOwner
      originalPurchaser
      newOrUsed
      companyNumber
      responsibleBusinessUnit
      location
      majorAccountingClass
      majorEquipmentClass
      manufacturer
      function
      categoryCode6
      status
      needsImaging
      isCovid
      attachment
    }
  }
`;
